import { render } from "./ProfileLearnToolbarSubpage.vue?vue&type=template&id=34bcb937&scoped=true"
import script from "./ProfileLearnToolbarSubpage.vue?vue&type=script&lang=js"
export * from "./ProfileLearnToolbarSubpage.vue?vue&type=script&lang=js"

import "./ProfileLearnToolbarSubpage.vue?vue&type=style&index=0&id=34bcb937&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bcb937"]])

export default __exports__